import { Box, Tooltip, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import GrayBGText from "./GrayBGText";

function JobCities({ cities }) {
  const location = useLocation();
  const isLandingPageRoute = location.pathname === "/";
  const remainingCities = cities.slice(1).join(" | ");
  const typographyStyles = {
    fontSize: "1rem"
  };
  return (
    <>
      {cities && (
        <Box
          display={"flex"}
          alignItems={"flex-end"}
          flexWrap={"wrap"}
          gap={1}
          sx={{ mb: 1, maxWidth: "800px" }}
        >
          {isLandingPageRoute && <Typography sx={typographyStyles}>{`${cities[0]} `}</Typography>}
          {isLandingPageRoute && cities.length > 1 && (
            <Tooltip title={remainingCities}>
              <span style={{ cursor: "pointer" }}>
                <GrayBGText loc={`+${cities.length - 1}`} />
              </span>
            </Tooltip>
          )}
          {!isLandingPageRoute &&
            cities.length > 0 &&
            cities.map((city) => (
              <Typography sx={typographyStyles} key={city.toLowerCase()}>
                {city}
              </Typography>
            ))}
        </Box>
      )}
    </>
  );
}

export default JobCities;
